import React, { useContext, useState } from "react";
import { Container, Table, Form, Button, Card } from "react-bootstrap";
import { CartContext } from "../../context/CartContext";
import "./TotalBill.css"; // Ensure you create this file for custom styles
import NavBar from "./NavBar";

const TotalBill = () => {
  const { orderSummary } = useContext(CartContext);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [enteredOtp, setEnteredOtp] = useState("");
  const [contactNumber, setContactNumber] = useState("");

  const handleProceedToPay = () => {
    const number = prompt("Please enter your 10-digit contact number:");

    if (number && number.length === 10) {
      setContactNumber(number);
      // Simulate sending OTP
      setOtpSent(true);
      alert("OTP has been sent to your contact number.");
    } else if (number) {
      alert("Please enter a valid 10-digit contact number.");
    } else {
      alert("Contact number is required.");
    }
  };

  const handleOtpVerification = () => {
    if (enteredOtp === otp) {
      alert("OTP verified. Proceeding to payment...");
      // Here you can add your payment processing logic
    } else {
      alert("Invalid OTP. Please try again.");
    }
  };

  const handleGenerateOtp = () => {
    // Simulate OTP generation
    const generatedOtp = Math.floor(1000 + Math.random() * 9000).toString();
    setOtp(generatedOtp);
    alert(`Your OTP is: ${generatedOtp}`);
  };

  if (!orderSummary) {
    return (
      <div>
        <NavBar title="La'RIVERA INN" />
        <Container>
          <h2>Total Bill</h2>
          <p>No order placed yet.</p>
        </Container>
      </div>
    );
  }

  return (
    <div>
      <NavBar title="La'RIVERA INN" />
      <Container>
        <h2>Total Bill</h2>
        <p>Customer Name: {orderSummary.customerName}</p>
        <p>Order Date: {orderSummary.orderDate}</p>
        <Table striped bordered>
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Item Price</th>
              <th>Quantity</th>
              <th>Total Price</th>
            </tr>
          </thead>
          <tbody>
            {orderSummary.items.map((item) => (
              <tr key={item.id} className="table-row">
                <td>
                  {item.name} {item.option && `(${item.option})`}
                </td>
                <td>${item.price ? item.price.toFixed(2) : "N/A"}</td>
                <td>{item.quantity}</td>
                <td>
                  $
                  {item.price ? (item.price * item.quantity).toFixed(2) : "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="3" className="text-end">
                Total:
              </td>
              <td>
                $
                {orderSummary.totalAmount
                  ? orderSummary.totalAmount.toFixed(2)
                  : "N/A"}
              </td>
            </tr>
          </tfoot>
        </Table>
        <div className="contact-container">
          <Card className="contact-box">
            <Card.Body>
              <Button
                variant="primary"
                onClick={handleProceedToPay}
                className="button w-100"
              >
                Proceed to Pay
              </Button>
              {otpSent && (
                <div className="otp-section mt-3">
                  <p>
                    An OTP has been sent to {contactNumber}. Please enter it
                    below:
                  </p>
                  <Button variant="secondary" onClick={handleGenerateOtp}>
                    Generate OTP
                  </Button>
                  <Form.Group controlId="otp" className="mt-3">
                    <Form.Label>Enter OTP</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter OTP"
                      value={enteredOtp}
                      onChange={(e) => setEnteredOtp(e.target.value)}
                    />
                  </Form.Group>
                  <Button
                    variant="primary"
                    onClick={handleOtpVerification}
                    className="button w-100 mt-3"
                  >
                    Verify OTP
                  </Button>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default TotalBill;
